
import { defineComponent, nextTick, onMounted, ref, watch } from 'vue';
import Farmer from '@/views/Farmer.vue';

export default defineComponent({
  components: { Farmer }
});
